import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';

import { Alert, Button, Card, Spinner } from '@src/components';
import i18n from '@src/i18n';
import { logAndFormatError } from '@src/services/error-formatter';
import { getAuth0Locale } from '@src/utils/auth0';

function SignupPage(): JSX.Element {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const { t } = useTranslation();

  const [error, setError] = useState<string | null>(null);

  const redirectToSignup = useCallback((): void => {
    // make sure we redirect with any search params for rewardful
    const defaultReturnTo = `/${window.location.search}`;

    loginWithRedirect({
      appState: { returnTo: defaultReturnTo },
      authorizationParams: {
        screen_hint: 'signup',
        ui_locales: getAuth0Locale(i18n.language),
      },
    }).catch((err) => {
      setError(logAndFormatError(err));
    });
  }, [loginWithRedirect]);

  useEffect(() => {
    if (!isAuthenticated) {
      redirectToSignup();
    }
  }, [isAuthenticated, redirectToSignup]);

  // if they are already authenticated, redirect them to home
  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex h-full items-center justify-center bg-gray-100">
      {error ? (
        <Card className="space-y-4 p-4">
          <Alert type="error">{error}</Alert>
          <Button onClick={redirectToSignup}>
            {t('buttons.try_again', 'Try Again')}
          </Button>
        </Card>
      ) : (
        <Spinner size="large" />
      )}
    </div>
  );
}

export default SignupPage;
